<template>
  <div class="row border-bottom border-2 border-gray-200 py-3">
    <h2> {{ $t('payslip.title.pension') }} </h2>
    <PayslipPensionForm
        v-for="(pension, index) in formData.pensions"
        :key="pension.id + index"
        :id="'payslip-social-pension-'+index"
        :index="index"
        :pension="pension"
        :currency="currency"
        @delete-row="removePensionRow"
        :base-salary="base_salary"
        :pension-type="pensionTypesEnums.EMPLOYEE_PENSION"
        :parent-id="parentId"
    />
    <div class="col-12 d-flex justify-content-end align-items-end float-end my-5">
      <div class="justify-content-end align-items-end float-end my-1">
        <a class="btn btn-primary" @click.prevent="addPensionRow">
          {{ $t('payslip.new.addPension') }}
        </a>
      </div>
    </div>
  </div>
  <div class="row py-3">
    <h2> {{ $t('payslip.title.taxes') }} </h2>
    <PayslipTaxForm
        v-for="(tax, index) in formData.taxes"
        :key="tax.id + index"
        :id="'payslip-social-tax-'+index"
        :index="index"
        :tax="tax"
        :currency="currency"
        @delete-row="removeTaxRow"
        :base-salary="base_salary"
        :tax-type="payrollTaxStatusEnums.EMPLOYEE_TAXE"
        :parent-id="parentId"
    />
    <div class="col-12 d-flex justify-content-end align-items-end float-end my-5">
      <div class="justify-content-end align-items-end float-end my-1">
        <a class="btn btn-primary" @click.prevent="addTaxRow">
          {{ $t('payslip.new.addTax') }}
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>

import { defineProps, ref } from "vue";
import PayslipPensionForm from "@/Modules/RH/components/Payslip/PayslipPensionForm.vue";
import PayslipTaxForm from "@/Modules/RH/components/Payslip/PayslipTaxForm.vue";
import {usePayslipEnums} from "@/Modules/RH/composables/payslipEnums";

const props = defineProps({
  parentId: String,
  base_salary: String,
  currency: {type: String, default: 'CFA'},
  data: {
    type: Object,
    default: () => ({
      base_salary: '',
      pensions: [
        {
          id: '',
          value: 0,
          edited: false
        }
      ],
      taxes: [
        {
          id: '',
          value: 0,
          edited: false
        }
      ],
    })
  }
})

const { pensionTypesEnums, payrollTaxStatusEnums } = usePayslipEnums()
const formData = ref(props.data)

const addPensionRow = () => {
  formData.value.pensions.push({
    id: '',
    value: 0,
    edited: false
  })
}
const removePensionRow = (index) => {
  if (formData.value.pensions.length > 0) {
    const [pensionToDelete] = formData.value.pensions.splice(index, 1)
  }
}

const addTaxRow = () => {
  formData.value.taxes.push({
    id: '',
    value: 0,
    edited: false
  })
}
const removeTaxRow = (index) => {
  if (formData.value.taxes.length > 0) {
    const [taxToDelete] = formData.value.taxes.splice(index, 1)

  }
}
</script>

<style scoped>

</style>